import {
  type NavScope,
  ROUTE_PUBLIC_PATHS,
  getRoutePermissionRules,
} from '../constants/menu-route-permissions';

// ----------------------------------------------------------------------

/** 将路由模式转为正则（支持 :param 动态段） */
function patternToRegExp(pattern: string): RegExp {
  const source = pattern
    .split('/')
    .map((segment) => {
      if (!segment) return '';
      if (segment.startsWith(':')) return '[^/]+';
      return segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    })
    .join('/');

  return new RegExp(`^${source}$`);
}

/** 规范化路径（去除末尾斜杠） */
function normalizePathname(pathname: string): string {
  if (!pathname || pathname === '/') return pathname;
  return pathname.replace(/\/+$/, '');
}

// ----------------------------------------------------------------------

/**
 * 解析当前路由所需的权限码
 *
 * @returns 所需权限码；null 表示无需 ACL 或未配置规则（放行）
 */
export function resolveRoutePermission(scope: NavScope, pathname: string): string | null {
  const normalized = normalizePathname(pathname);

  if (ROUTE_PUBLIC_PATHS[scope].includes(normalized)) {
    return null;
  }

  const rules = getRoutePermissionRules(scope);

  for (const rule of rules) {
    if (patternToRegExp(rule.pattern).test(normalized)) {
      return rule.permissionCode;
    }
  }

  return null;
}
